import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { CORAL, MUTED, NAVY } from "../constants";

export function EmptyState({ message }) {
  return (
    <div
      className="rounded-2xl bg-white px-6 py-14 text-center shadow-sm"
      style={{ borderTop: `3px solid ${CORAL}` }}
    >
      <div
        className="w-10 h-10 rounded-xl mx-auto flex items-center justify-center mb-4"
        style={{ background: `${CORAL}14` }}
      >
        <FontAwesomeIcon icon={faFilter} className="text-sm" style={{ color: CORAL }} />
      </div>
      <p className="text-sm font-black mb-1" style={{ color: NAVY }}>Nothing to show yet</p>
      <p className="text-xs" style={{ color: MUTED }}>{message}</p>
    </div>
  );
}
